import { Component, inject, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";

@Component({
  selector: "app-confirmation",
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: "./confirmation.component.html",
  styleUrl: "./confirmation.component.scss",
})
export class ConfirmationComponent {
  defaultContent = {
    title: "Confirm Action",
    message: "Are you sure you want to perform this action?",
  };
  dialog = inject(MatDialogRef<ConfirmationComponent>);

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { title: string; message: string },
  ) {}
}
